<div role="listbox" id="adf-search-results-content" title="{{'PERMISSION_MANAGER.ADD-PERMISSION.USER-GROUP-LIST' | translate}}"
    [ngClass]="_classList" #panel>
    <ng-template
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: results }">
    </ng-template>
</div>
